import { useMemo, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { showcases, showcasesBasic, showAdmin } from "../data/homepageData";

function ShowcaseCard({ item, index }) {
  return (
    <section className={`rz-showcase ${item.reverse ? "rz-showcase--reverse" : ""}`}>
      <div className="rz-showcase__copy">
        {typeof index === "number" && (
          <span className="rz-showcase__index">
            {String(index + 1).padStart(2, "0")}
          </span>
        )}
        <p className="rz-kicker">{item.kicker}</p>
        <h3>{item.title}</h3>
        <p>{item.text}</p>
      </div>

      <div className="rz-showcase__media">
        <img src={item.image} alt={item.title} />
      </div>
    </section>
  );
}

export default function ShowcaseSection({ onOpenDemo }) {
  const [activeTab, setActiveTab] = useState("pro");

  const activeShowcases = useMemo(() => {
    return activeTab === "pro" ? showcases : showcasesBasic;
  }, [activeTab]);

  return (
    <section className="rz-section rz-section--light rz-section--showcase" id="platforma">
      <div className="rz-shell">
        <div className="rz-section-heading rz-section-heading--split">
          <div>
            <p className="rz-kicker">Demo platformă</p>
            <h2>O structură clară și modernă, gândită să atragă rezervări.</h2>
          </div>
          <p>
            Păstrăm esența locației tale, dar organizăm totul într-o prezentare clară,
            care atrage oaspeți și îi duce rapid către rezervare.
          </p>
        </div>

        <div className="rz-showcase-tabs-wrap">
          <div className="rz-showcase-tabs" role="tablist" aria-label="Tip demo">
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "pro"}
              className={`rz-showcase-tab ${activeTab === "pro" ? "is-active" : ""}`}
              onClick={() => setActiveTab("pro")}
            >
              Pro
            </button>

            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "basic"}
              className={`rz-showcase-tab ${activeTab === "basic" ? "is-active" : ""}`}
              onClick={() => setActiveTab("basic")}
            >
              Basic
            </button>
          </div>
        </div>

        <div className="rz-showcase-stack">
          {activeShowcases.map((item, index) => (
            <ShowcaseCard item={item} key={`${activeTab}-${item.title}`} index={index} />
          ))}

          {showAdmin.map((item) => (
            <ShowcaseCard item={item} key={item.title} />
          ))}
        </div>

        {/* <div className="rz-showcase__footer">
          <button type="button" onClick={onOpenDemo} className="rz-btn rz-btn--primary">
            Vezi demo-urile
            <ArrowUpRight size={16} />
          </button>
        </div> */}
      </div>
    </section>
  );
}